import { render, staticRenderFns } from "./DatatableFilters.vue?vue&type=template&id=0a0ddf44"
import script from "./DatatableFilters.vue?vue&type=script&lang=js"
export * from "./DatatableFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports